// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Works from './pages/Works';
import AboutContact from './pages/AboutContact';
import Admin from './pages/Admin';
import WorkDetail from './pages/WorkDetail';
import WorksList from "./pages/WorksList";
import ContactPage from "./pages/ContactPage";

function App() {
    return (
        <>
            {/* Google Translate otomatik çeviriyi devre dışı bırakmak için meta ve htmlAttributes */}
            <Helmet htmlAttributes={{ translate: 'no', lang: 'tr' }}>
                <meta name="google" content="notranslate" />
            </Helmet>
            <BrowserRouter>
                <Navbar />
                {/* Navbar yüksekliği kadar boşluk bırakmak için mt: 8 (64px) ekliyoruz */}
                <Box sx={{ mt: 8 }}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/biografi" element={<AboutContact />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/works" element={<WorksList />} />
                        <Route path="/works/:seriesId" element={<WorksList />} />
                        <Route path="/works/:id/detail" element={<WorkDetail />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </Box>
            </BrowserRouter>
        </>
    );
}

export default App;
